import { useState } from 'react'

interface UseStepperOptions {
  initialStep?: number
  steps: number
}

export const useStepper = ({ initialStep = 0, steps }: UseStepperOptions) => {
  const [currentStep, setCurrentStep] = useState(initialStep)
  const [priorStep, setPriorStep] = useState(initialStep)

  const next = () => {
    setPriorStep(currentStep)
    setCurrentStep((prev) => Math.min(prev + 1, steps - 1))
  }
  const prev = () => {
    setPriorStep(currentStep)
    setCurrentStep((prev) => Math.max(prev - 1, 0))
  }

  const goToStep = (step: number) => {
    setPriorStep(currentStep)
    setCurrentStep(Math.max(0, Math.min(step, steps - 1)))
  }

  return {
    currentStep,
    priorStep,
    next,
    prev,
    goToStep,
    isFirstStep: currentStep === 0,
    isLastStep: currentStep === steps - 1
  }
}
